var cilFullscreen = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='208 48 208 16 16 16 16 208 48 208 48 70.627 208.687 231.313 231.313 208.687 70.627 48 208 48' class='ci-primary'/><polygon fill='var(--ci-primary-color, currentColor)' points='464 304 464 441.373 299.313 276.687 276.687 299.313 441.373 464 304 464 304 496 496 496 496 304 464 304' class='ci-primary'/>"];

export { cilFullscreen };

